module.exports = __webpack_public_path__ + "img/PtownWebAssessorPageParking2014_1.1a2144b8.png";